import { useQuery } from '@tanstack/react-query';

import { captureException } from '../../logger/Logger';
import { useMastraClient } from '../providers/MastraClient';
import type { DatasetView } from './loadDataset';
import { loadDataset } from './loadDataset';

export const useDataset = (
    agentId: string,
): {
    dataset: DatasetView | null;
    isLoading: boolean;
    isError: boolean;
} => {
    const client = useMastraClient();
    const { data, isLoading, isError } = useQuery({
        queryKey: ['dataset', agentId],
        queryFn: async () => {
            try {
                return await loadDataset(client, agentId);
            } catch (error) {
                captureException(error);
                throw error;
            }
        },
        enabled: agentId !== '',
    });

    return {
        dataset: data ?? null,
        isLoading,
        isError,
    };
};
